export default {
  search: {
    title: "Buscar",
    trending: "Em alta",
    noResults: 'Nenhum resultado encontrado para "{{query}}"',
    sections: {
      games: "Jogos",
      props: "Props",
      position: "Posição",
      trending: "Em alta",
      players: "Jogadores",
      teams: "Equipes",
      markets: "Mercados",
      matchups: "Confrontos",
    },
    empty: {
      noResults: 'Nenhum resultado encontrado para "{{query}}"',
      noGamesAvailable: "Nenhum jogo disponível",
      checkBackLater: "Volte mais tarde",
    },
    actions: {
      searchByGame: "Buscar por jogo",
      viewMatchups: "Ver confrontos",
      searchByProp: "Buscar por prop",
      searchByPosition: "Buscar por posição",
    },
    discovery: {
      Hits: "Rebatidas",
      "Total Bases": "Bases totais",
      RBI: "RBI",
      Strikeouts: "Strikeouts",
      Results: "Resultados",
      Totals: "Totais",
      "Goals & Assists": "Gols e assistências",
      "Shots on Goal": "Chutes no gol",
      Points: "Pontos",
      "Powerplay Points": "Powerplay Points",
    },
    positions: {
      Forwards: "Atacantes",
      Midfielders: "Meio-campistas",
      Defense: "Defesa",
      Guards: "Guards",
      Centers: "Centers",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Pontas",
      Goalies: "Goleiros",
      Pitchers: "Arremessadores",
      Hitters: "Rebatedores",
    },
  },
};